import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../../shared/components/data-table/DataTable";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../../shared/components/tooltip/Tooltip";

const DataAlertsDashboardTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "subjects",
      header: "",
      cell: ({ row }) => (
        <Tooltip>
          <TooltipTrigger>
            <Info />
          </TooltipTrigger>
          <TooltipContent>{row.getValue("subjects")}</TooltipContent>
        </Tooltip>
      ),
    },
    {
      accessorKey: "severity",
      header: t("dashboards.dataAlerts.table.header.severity"),
    },
    {
      accessorKey: "tags",
      header: t("dashboards.dataAlerts.table.header.tags"),
    },
    {
      accessorKey: "message",
      header: t("dashboards.dataAlerts.table.header.message"),
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default DataAlertsDashboardTable;
